import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

const handleResponseError = (response) => {
	if (response && response.data && response.data.message) {
		toastError(response.data.message);
	} else {
		toastError('Something went wrong!');
	}
};

export const searchSalesContructs = async (param) => {
	try {
		const { data } = await ApiClient.GET('searchSalesContruct', param);
		if (data && data.length) {
			const responseData = data.map((item) => {
				return {
					...item,
					value: item?.contractNo
				};
			});
			return responseData;
		}
	} catch (response) {
		handleResponseError(response);
	}
};

export const fetchAllAmendments = async (id) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/sales-contract/${id}/amendments`, '', true);
		if (data && data.length) {
			const responseData = data.map((item) => {
				return {
					...item,
					value: item?.amendmentNo
				};
			});
			return responseData;
		} else {
			return [];
		}
	} catch (response) {
		handleResponseError(response);
	}
};

export const onAddNewSalesContruct = async (setLoading) => {
	try {
		setLoading(true);
		const { data } = await ApiClient.POST('createSalesContruct', {});
		toastSuccess('Sales contruct created.');
		return data;
	} catch (response) {
		handleResponseError(response);
	} finally {
		setLoading(false);
	}
};

export const onAddNewAmendment = async (id, setLoading) => {
	try {
		setLoading(true);
		const { data } = await ApiClient.POST(
			`${BASE_URL}/sales-contract/${id}/amendment/create`,
			{},
			'',
			true
		);
		toastSuccess('Amendment created.');
		return data;
	} catch (response) {
		handleResponseError(response);
	} finally {
		setLoading(false);
	}
};

export const onUpdateContructDetails = async (requestBody, id, setLoading) => {
	try {
		setLoading(true);
		const { data } = await ApiClient.POST('updateSalesContruct', requestBody, id);
		toastSuccess('Sales contruct updated.');
		return data;
	} catch (response) {
		handleResponseError(response);
	} finally {
		setLoading(false);
	}
};

export const getAmendmentWiseSalesContruct = async (salesContructId, amendmentId, setLoading) => {
	const param = amendmentId ? `?amendmentId=${amendmentId}` : '';
	try {
		setLoading(true);
		const { data } = await ApiClient.GET(
			`${BASE_URL}/sales-contract/${salesContructId}/amendment`,
			param,
			true
		);
		return data;
	} catch (response) {
		handleResponseError(response);
	} finally {
		setLoading(false);
	}
};
